import { render, staticRenderFns } from "./Orcamento.vue?vue&type=template&id=0b38a078&scoped=true"
import script from "./Orcamento.vue?vue&type=script&lang=js"
export * from "./Orcamento.vue?vue&type=script&lang=js"
import style0 from "./Orcamento.vue?vue&type=style&index=0&id=0b38a078&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b38a078",
  null
  
)

export default component.exports